import React, { Component } from "react"
import TestCaseWidget from "./TestCaseWidget"
import { getDomainFrom } from "./domain"

/**
 * This is the code that performs the test for one site.
 * It can either fetch a url, load an image, or load an iframe
 * To test success.
 */

class UrlTest extends Component {
    constructor(props) {
        super(props)
        this.state = {
            testid: Math.random(),
            resource: props.resource,
            url: "https://" + props.resource + "/proxy-test/payload.json",
            status: "testing",
            err: ""
        }
    }
    succeed() {
        this.setState({ status: "pass" })
        this.props.successCallback()
    }
    fail(err) {
        console.log("FAIL:", this.props.resource, "reason:", err)
        this.setState({
            status: "fail",
            err: err
        })
        this.props.errorCallback()
    }

    getResource = () => {
        const serverName = this.props.resource
        const currentDomain = getDomainFrom(serverName)

        if (serverName.startsWith("relay")) {
            // check API gateway /test endpoint
            fetch(`https://relay.${currentDomain}/test`, { cache: "no-cache" })
                .then(data => {
                    this.succeed()
                })
                .catch(err => {
                    this.fail(err)
                })
        } else if (serverName.startsWith("heimdall")) {
            // ensure AUTH api can be reached
            fetch(`https://heimdall.${currentDomain}`, {
                mode: "no-cors",
                cache: "no-cache"
            })
                .then(data => {
                    this.succeed()
                })
                .catch(err => {
                    this.fail(err)
                })
        } else {
            // Default test: fetch the URL.
            // We have proxy-test urls configured through cloudfront
            // to test whether a JSON file can be retrieved.
            console.log("fetching...", this.state.url)
            fetch(this.state.url, { cache: "no-cache" })
                .then(response => {
                    console.log(response)
                    if (!response.ok) {
                        throw Error(response.statusText)
                    }
                    return response.json()
                })
                .then(responseJSON => {
                    try {
                        // there is a JSON file in an test s3 bucket that has
                        // { status: 200 , testdidcomplete: true}
                        // the test s3 bucket is configured as a rule in cloudfront.
                        if (responseJSON && responseJSON.testdidcomplete) {
                            this.succeed()
                        } else {
                            this.fail(
                                "JSON result did not contain 'testdidcomplete'\n JSON returned:" +
                                    JSON.stringify(responseJSON, null, 2)
                            )
                        }
                    } catch (e) {
                        this.fail(
                            JSON.stringify({
                                e,
                                responseJSON,
                                url: this.state.url
                            })
                        )
                    }
                })
                .catch(err => {
                    this.fail(JSON.stringify({ err, url: this.state.url }))
                })
        }
    }

    componentDidMount() {
        this.getResource()
    }

    render() {
        return (
            <React.Fragment>
                {this.uiToRender && this.uiToRender()}
                <TestCaseWidget
                    resource={this.state.resource}
                    status={this.state.status}
                    err={this.state.err}
                />
            </React.Fragment>
        )
    }
}

export default UrlTest



// WEBPACK FOOTER //
// ./src/UrlTest.js